export default {
  data() {
    return {
      appEnv: CURRENT_ENV
    };
  },
  methods: {
    navigateHome() {
      location.href = "/";
    },   
  }
};
